import axios from '../../axios'

/*
 * 院校数据接口
 */
// 获取专业列表（基础数据）
export const getprofList = (data) => {
    return axios({
        url: '/api/data/wish/prof',
        method: data.method,
        data: data.data
    })
}

// 标签管理
export const typeList = (data) => {
    return axios({
        url: '/api/data/wish/type/list',
        method: 'GET',
        data
    })
}

// all标签
export const allTypeList = (data) => {
    return axios({
        url: '/api/data/wish/type',
        method: data.method,
        data: data.data
    })
}

// 专业备注
export const remarkList = (data) => {
    return axios({
        url: '/api/data/wish/remark',
        method: data.method,
        data: data.data
    })
}

// 专业搜索
export const searchProf = (data) => {
    return axios({
        url: '/api/data/wish/search/prof',
        method: 'GET',
        data
    })
}

// 省份批次
export const batchList = (data) => {
    return axios({
        url: '/api/data/wish/batch',
        method: data.method,
        data: data.data
    })
}

// 省份批次线
export const getLineList = (data) => {
    return axios({
        url: '/api/data/wish/line',
        method: data.method,
        data: data.data
    })
}

// 省份文理科列表 dataYear,provinceId
export const getAosList = (data) => {
    return axios({
        url: '/api/data/wish/province/aos',
        method: 'GET',
        data: data
    })
}

// 省份统考类别 参数dataYear,provinceId
export const getCategoryList = (data) => {
    return axios({
        url: '/api/data/wish/province/joint/category',
        method: 'GET',
        data: data
    })
}

// 查询省份批次线 参数dataYear,provinceId
export const proBatchList = (data) => {
    return axios({
        url: '/api/data/wish/province/batch',
        method: 'GET',
        data: data
    })
}

// 添加统考类别（基础数据）
export const getJointCategoryList = (data) => {
    return axios({
        url: '/api/data/wish/jointCategory',
        method: data.method,
        data: data.data
    })
}

// 所有统考类别
export const getAllCategory = (data) => {
    return axios({
        url: '/api/data/wish/joint/category',
        method: 'GET',
        data: data
    })
}

// 省份统考类别
export const getProvJointCategory = (data) => {
    return axios({
        url: '/api/data/wish/provJointCategory',
        method: data.method,
        data: data.data
    })
}

// 院校排名分类
export const getRankcategory = (data) => {
    return axios({
        url: '/api/data/wish/rankcategory',
        method: data.method,
        data: data.data
    })
}

// 院校专业
export const getSchoolprof = (data) => {
    return axios({
        url: '/api/data/wish/schoolprof',
        method: data.method,
        data: data.data
    })
}

// 专业详情
export const getProfInfo = (data) => {
    return axios({
        url: '/api/data/wish/schoolprof/info',
        method: 'GET',
        data: data
    })
}

// 院校搜索
export const getSchool = (data) => {
    return axios({
        url: '/api/data/wish/search/school',
        method: 'GET',
        data: data
    })
}

// 导入
export const importJointCate = (data) => {
    return axios({
        url: '/api/data/wish/jointCategory/import',
        method: 'POST',
        data: data
    })
}

// 导出
export const exportJointCate = (data) => {
    return axios({
        url: '/api/data/wish/jointCategory/export',
        method: 'POST',
        data: data
    })
}

// 批量更新
export const updateJointCate = (data) => {
    return axios({
        url: '/api/data/wish/jointCategory/batch/update',
        method: 'POST',
        data: data
    })
}

// 批量删除
export const queryDelJointCate = (data) => {
    return axios({
        url: '/api/data/wish/jointCategory/batch/delete',
        method: 'POST',
        data: data
    })
}

// 模糊搜索专业备注
export const getRemarkList = (data) => {
    return axios({
        url: '/api/data/wish/search/remark',
        method: 'GET',
        data: data
    })
}

// 省统考类型导入
export const importProvJointCategory = (data) => {
    return axios({
        url: '/api/data/wish/provJointCategory/import',
        method: 'POST',
        data: data
    })
}

// 省统考类型导出
export const exportProvJointCategory = (data) => {
    return axios({
        url: '/api/data/wish/provJointCategory/export',
        method: 'POST',
        data: data
    })
}

// 省统考类型批量更新
export const updateProvJointCategory = (data) => {
    return axios({
        url: '/api/data/wish/provJointCategory/batch/update',
        method: 'POST',
        data: data
    })
}

// 省统考类型批量删除
export const queryDelProvJointCategory = (data) => {
    return axios({
        url: '/api/data/wish/provJointCategory/batch/delete',
        method: 'POST',
        data: data
    })
}




// WEBPACK FOOTER //
// ./src/http/moudules/wish/prof.js